export const APP_THEME = {
  colors: {
    primary: '#FF6B6B',
    secondary: '#4ECDC4',
    accent1: '#FFE66D',
    accent2: '#96CEB4',
    accent3: '#FFEEAD',
    accent4: '#FF9999',
    text: '#363636',
    background: '#FFFFFF',
    pageBg: '#FFF5F5',
  },
};
